import React from 'react'

const ClientInfoModal = () => {
    return (
        <div>
            <h3>Tietoa Pentistä</h3>


            <p><b>Ikä, sairaudet </b>
                Pentti Elo, 88 vuotta. Asuu yksin 3-kerroksisen kerrostalon ylimmässä kerroksessa osoitteessa Elonkaari 9. Ja jotain muuta relevanttia tähän.. <br /><br />

                <b>Lonkan nivelrikko/ menissa keinoniveloperaatioon: </b> Pentti on käynyt hakemassa apuvälinelainaamosta liikkumisen apuvälineitä ja tarvitsee ohjausta niiden käyttöön.
                <br /><br />
                <b> Muuta:</b>Tytär Leena on ollut yhteydessä kotihoitoon, kovasti unohtelua ja autolla eksymisiä tutuilla reiteillä, epäilee että olisi alkava muistisairaus ja kovasti huolissaan pärjääkö Pentti kotona <br /><br />
                <b>Lääkkeet: </b> tähän jotain tietoa lääkkeistä
            </p>





        </div>
    )
}

export default ClientInfoModal